module.exports = __webpack_public_path__ + "img/icon-stim.e87f7b9a.svg";